import { IconButton, Tooltip } from '@mui/material';
import React, { useCallback, type MouseEvent } from 'react';
import { SIZES } from '../../../../../constants/constants';
import { useI18n } from '../../../../../i18n/I18n';
import { Icons } from '../../../../../icons/Icons';

type GridSettingsGearProps = {
    onOpen: () => void;
};

export function GridSettingsGear({ onOpen }: GridSettingsGearProps) {
    const t = useI18n();
    const settingsLabel = t('settings.title');

    const handleClick = useCallback(
        function handleClick(event: MouseEvent<HTMLElement>) {
            event.stopPropagation();
            onOpen();
        },
        [onOpen]
    );

    return (
        <Tooltip title={settingsLabel}>
            <IconButton
                size={SIZES.small}
                data-testid="dataGridSettings"
                aria-label={settingsLabel}
                sx={{ p: 0 }}
                onClick={handleClick}
            >
                <Icons.Configuration />
            </IconButton>
        </Tooltip>
    );
}
